import { opacify } from "utils"
import { baseTheme } from "../base"

export const buttonsStatesColors = {
  containedPrimary: {
    "&:hover": {
      backgroundColor: baseTheme.palette.primary[500],
    },
    "&:focus-visible": {
      backgroundColor: baseTheme.palette.primary[400],
    },
    "&:active": {
      backgroundColor: baseTheme.palette.primary[300],
    },
  },
  containedSecondary: {
    "&:hover": {
      backgroundColor: baseTheme.palette.secondary[500],
    },
    "&:focus-visible": {
      backgroundColor: baseTheme.palette.secondary[400],
    },
    "&:active": {
      backgroundColor: baseTheme.palette.secondary[300],
    },
  },
  noBackgroundDark: {
    "&:hover": {
      backgroundColor: opacify(baseTheme.palette.common.black, 0.1),
    },
    "&:focus-visible": {
      backgroundColor: opacify(baseTheme.palette.common.black, 0.2),
    },
    "&:active": {
      backgroundColor: opacify(baseTheme.palette.common.black, 0.3),
    },
  },
  noBackgroundLight: {
    "&:hover": {
      backgroundColor: opacify(baseTheme.palette.common.white, 0.1),
    },
    "&:focus-visible": {
      backgroundColor: opacify(baseTheme.palette.common.white, 0.2),
    },
    "&:active": {
      backgroundColor: opacify(baseTheme.palette.common.white, 0.3),
    },
  },
  outlinedPrimary: {
    "&:hover": {
      backgroundColor: baseTheme.palette.primary[100],
    },
    "&:focus-visible": {
      backgroundColor: baseTheme.palette.primary[200],
    },
    "&:active": {
      backgroundColor: baseTheme.palette.primary[300],
    },
  },
  outlinedSecondary: {
    "&:hover": {
      backgroundColor: baseTheme.palette.secondary[100],
    },
    "&:focus-visible": {
      backgroundColor: baseTheme.palette.secondary[200],
    },
    "&:active": {
      backgroundColor: baseTheme.palette.secondary[300],
    },
  },
}
